import { DealerStatus } from '../../constants/DealerStatus';

export const dealersDataMockup = [
  {
    id: 1,
    name: 'JS Car Dealer #1',
    email: 'j@smith.com',
    registeredDate: '09/12/2020',
    status: DealerStatus.ACTIVE,
  },
  {
    id: 2,
    name: 'JS Car Dealer #2',
    email: 'j@smith.com',
    registeredDate: '19/12/2020',
    status: DealerStatus.ACTIVE,
  },
  {
    id: 3,
    name: 'JS Car Dealer #3',
    email: 'j@smith.com',
    registeredDate: '09/12/2020',
    status: DealerStatus.ACTIVE,
  },
  {
    id: 4,
    name: 'JS Car Dealer #4',
    email: 'j@smith.com',
    registeredDate: '09/12/2020',
    status: DealerStatus.ACTIVE,
  },
  {
    id: 5,
    name: 'JS Car Dealer #5',
    email: 'j@smith.com',
    registeredDate: '09/12/2020',
    status: DealerStatus.DELETED,
  },
  {
    id: 6,
    name: 'JS Car Dealer #6',
    email: 'j@smith.com',
    registeredDate: '09/12/2020',
    status: DealerStatus.ACTIVE,
  },
  {
    id: 7,
    name: 'JS Car Dealer #7',
    email: 'j@smith.com',
    registeredDate: '11/11/2011',
    status: DealerStatus.INACTIVE,
  },
  {
    id: 8,
    name: 'JS Car Dealer #8',
    email: 'j@smith.com',
    registeredDate: '09/12/2020',
    status: DealerStatus.PENDING,
  },
  {
    id: 9,
    name: 'JS Car Dealer #9',
    email: 'j@smith.com',
    registeredDate: '09/12/2020',
    status: DealerStatus.PENDING,
  },
  {
    id: 10,
    name: 'JS Car Dealer #10',
    email: 'j@smith.com',
    registeredDate: '09/12/2020',
    status: DealerStatus.ACTIVE,
  },
  {
    id: 11,
    name: 'JS Car Dealer #11',
    email: 'j@smith.com',
    registeredDate: '09/12/2020',
    status: DealerStatus.ACTIVE,
  },
  {
    id: 12,
    name: 'JS Car Dealer #12',
    email: 'j@smith.com',
    registeredDate: '09/12/2020',
    status: DealerStatus.ACTIVE,
  },
];
